import React, { ReactNode } from 'react';
import { Loader } from '../../ui-library';
import WidgetError from '../WidgetError';

type PreloaderProps = {
    isLoading?: boolean;
    error?: {
        type?: string;
        message: string;
    } | null | undefined;
    letChildrenToRenderOnError?: boolean;
    children: ReactNode;
}

const Preloader = ({
    isLoading = false,
    error = { message: '' },
    children,
    letChildrenToRenderOnError = false,
} : PreloaderProps) => {
    if (isLoading) return <Loader/>;

    if (error?.message && isLoading === false) {
        return (
            <>
                <WidgetError accent error message={error?.message || ''}/>
                {
                    letChildrenToRenderOnError && (
                        <>
                            <br/>
                            {children}
                        </>
                    )
                }
            </>
        );
    }

    return children;
};

export default Preloader;
